import React from 'react';

const Left = ({ className = '', onClick, disabled }) => (
    <span
        className={`arrow-button left ${className} ${disabled ? 'disabled' : ''}`}
        onClick={onClick}
    >
        <i className="caret fas fa-caret-left" />
    </span>
);

export default Left;
